module.exports = __webpack_public_path__ + "static/img/gold-button-down.acafe9fd.png";